import { useRouter } from "next/router";
import { useEffect, useState, useRef } from "react";
import useBrowserSettings from "./useBrowserSettings";
import useAuth0Token from "./useAuth0Token";
import { useQueryClient } from "react-query";

type TokenObj = { token: string };

const useAuth0 = () => {
  const { isGapp } = useBrowserSettings();
  const { setAuth0Token } = useAuth0Token();
  const [isTokenSet, setIsTokenSet] = useState(false);
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    if (!isGapp) return;

    // Function to send the token request
    const requestToken = () => {
      if ((window as any)?.ReactNativeWebView) {
        (window as any)?.ReactNativeWebView.postMessage("request-auth0-token");
        hasRequestedRef.current = true;
        return true;
      }
      return false;
    };

    // Try immediately
    if (requestToken()) return;

    // If bridge not ready, poll with setInterval (max 5 seconds)
    const interval = setInterval(() => {
      if (requestToken()) {
        clearInterval(interval);
      }
    }, 100); // check every 100ms

    // Safety timeout: stop polling after 5 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval);
      console.warn("ReactNativeWebView bridge not found after 5 seconds");
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isGapp]);

  // Event listener for the token (only added once)
  useEffect(() => {
    if (!isGapp) return;

    const handler = (e: any) => {
      console.log("Token received", e.detail);
      setAuth0Token({ token: e.detail.token });
      setIsTokenSet(true);
    };

    document.addEventListener("save-auth0-token", handler);
    return () => document.removeEventListener("save-auth0-token", handler);
  }, [isGapp, setAuth0Token]);

  return { isTokenSet };
};
export default useAuth0;
